/* HARMONY — Rastreio do pedido
   Portado do protótipo (harmony-prototype.html, "RASTREIO DO PEDIDO").

   ⚠️ Mesma limitação dos certificados (assets/certificates.js): isto lê
   localStorage["hmy_orders"], o mesmo registro local usado lá — não é
   pedido real da Shopify. Em produção, troque a busca abaixo por:
   - Shopify Customer Account API (pedidos reais do cliente logado), ou
   - o app de rastreio contratado (17Track, Rastreio.net, Melhor Envio),
     que devolve o código da transportadora e os eventos de entrega de
     verdade — a timeline por "dias desde a compra" abaixo é só uma
     simulação razoável enquanto não há transportadora real integrada.

   A timeline é derivada da data do pedido, então avança sozinha conforme os
   dias passam — nenhum status aparece antes de fazer sentido no calendário. */
(function () {
  var ORDERS_KEY = 'hmy_orders';

  // dias corridos desde a compra em que cada etapa passa a valer
  var STEPS = [
    { titleKey: 'confirmed', after: 0 },
    { titleKey: 'picking', after: 1 },
    { titleKey: 'shipped', after: 2 },
    { titleKey: 'transit', after: 4 },
    { titleKey: 'delivered', after: 8 }
  ];

  function getOrders() {
    try {
      return JSON.parse(window.localStorage.getItem(ORDERS_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function daysSince(iso) {
    try {
      return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
    } catch (e) {
      return 0;
    }
  }

  function fmtDate(iso) {
    try {
      var d = new Date(iso);
      var p = function (n) { return String(n).padStart(2, '0'); };
      return p(d.getDate()) + '.' + p(d.getMonth() + 1) + '.' + d.getFullYear();
    } catch (e) {
      return '—';
    }
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function init() {
    var root = document.querySelector('.hmy-track-page');
    if (!root || root._hmyInit) return;
    root._hmyInit = true;

    var form = document.getElementById('tk-form');
    var input = document.getElementById('tk-input');
    var out = document.getElementById('tk-result');
    if (!form || !input || !out) return;

    var strings = {
      steps: {
        confirmed: [root.getAttribute('data-step-confirmed-t'), root.getAttribute('data-step-confirmed-d')],
        picking: [root.getAttribute('data-step-picking-t'), root.getAttribute('data-step-picking-d')],
        shipped: [root.getAttribute('data-step-shipped-t'), root.getAttribute('data-step-shipped-d')],
        transit: [root.getAttribute('data-step-transit-t'), root.getAttribute('data-step-transit-d')],
        delivered: [root.getAttribute('data-step-delivered-t'), root.getAttribute('data-step-delivered-d')]
      },
      waiting: root.getAttribute('data-waiting-label') || 'aguardando',
      orderLabel: root.getAttribute('data-order-label') || 'PEDIDO',
      sizeLabel: root.getAttribute('data-size-label') || 'TAM',
      certLabel: root.getAttribute('data-cert-label') || 'CERT',
      notFound: root.getAttribute('data-not-found-template') || ''
    };

    function render(order) {
      var d = daysSince(order.date);
      var html = '<span class="tk-order-id">' + esc(strings.orderLabel) + ' ' + esc(order.id) + ' — ' + fmtDate(order.date) + '</span>';
      html += '<div class="tk-steps">';
      STEPS.forEach(function (s) {
        var done = d >= s.after;
        var pair = strings.steps[s.titleKey] || ['', ''];
        html += '<div class="tk-step' + (done ? ' done' : '') + '">'
          + '<span class="ts-t">' + esc(pair[0]) + '</span>'
          + '<span class="ts-d">' + (done ? esc(pair[1]) : esc(strings.waiting)) + '</span>'
          + '</div>';
      });
      html += '</div>';

      html += '<div class="tk-items">';
      (order.items || []).forEach(function (it) {
        html += '<div class="tk-item">'
          + (it.img ? '<img src="' + esc(it.img) + '" alt="">' : '')
          + '<div><span class="ti-n">' + esc(it.name) + '</span>'
          + '<span class="ti-m">' + esc(strings.sizeLabel) + ' ' + esc(it.size || '—')
          + ' &middot; ' + esc(strings.certLabel) + ' ' + esc(it.certId || '—') + '</span></div>'
          + '</div>';
      });
      html += '</div>';
      out.innerHTML = html;
      out.hidden = false;
    }

    function notFound(code) {
      var msg = strings.notFound.replace('[CÓDIGO]', esc((code || '').toUpperCase()));
      out.innerHTML = '<div class="tk-msg">' + msg + '</div>';
      out.hidden = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (input.value || '').trim().toUpperCase();
      if (!code) return;
      var orders = getOrders();
      var hit = null;
      orders.forEach(function (o) {
        if (o.id && o.id.toUpperCase() === code) hit = o;
        (o.items || []).forEach(function (it) {
          if (it.certId && it.certId.toUpperCase() === code) hit = hit || o;
        });
      });
      if (hit) render(hit); else notFound(code);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
